import { render, staticRenderFns } from "./column-after-buy.vue?vue&type=template&id=47d27e2c&scoped=true&"
import script from "./column-after-buy.vue?vue&type=script&lang=ts&"
export * from "./column-after-buy.vue?vue&type=script&lang=ts&"
import style0 from "./column-after-buy.vue?vue&type=style&index=0&id=47d27e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d27e2c",
  null
  
)

export default component.exports